var $ = require( 'jquery' );
import lazyLoad from 'vanilla-lazyload/dist/lazyload';
import Headroom from 'headroom.js';


let clickEvent = '';
if ( 'ontouchstart' in window ) {
	clickEvent = 'touchstart';
} else {
	clickEvent = 'click tap';
}

$( document ).ready( function() {
    initHeadroom();
	initLazyLoad();

	if ($(window).width() >= 1024) {
		$('.section-content-block__text-wrapper').append($('.section-content-block__text'));
		$('.section-content-block__text-wrapper').append($('.section-content-block__text-content'));
	} else {
		$('.section-content-block__text-wrapper').children($('.section-content-block__text')).remove();
		$('.section-content-block__text-wrapper').children($('.section-content-block__text-content')).remove();
	}
});

$( window ).on( 'load', function() {
	showBelowFold();
});

// $('img.hero-image').on('load', function() {
// 	showBelowFold();
// });

$( window ).resize( function() {

});


function initHeadroom() {
	var headerElements = document.getElementsByClassName("site-header"),
		headerElementsNo = headerElements.length;

	if ( headerElementsNo > 0 ) {
		for ( var i = 0; i < headerElementsNo; i++ ) {
			var headroom  = new Headroom( headerElements[i] );
			headroom.init();
		}
	}
}

function initLazyLoad() {
	new lazyLoad({
		elements_selector: '.lazy',
		load_delay: 300 //adjust according to use case
	});
}

function showBelowFold() {
    $('section.section').css('display', 'block');
}
